import { Link, useRouteLoaderData } from "@remix-run/react"
import dayjs from "dayjs"
import { cn } from "~/utils/shadecn"

export default function PromotionBanner() {
  const { user, sub } = useRouteLoaderData("root")

  return (
    <div
      className={cn(
        "relative bg-primary/90 text-center text-zinc-50 max-w-4xl mx-auto py-1 px-2 md:py-3 md:px-4 mb-4 rounded-lg",
        sub && sub.Package.RecurUnit === 12 && "hidden"
      )}>
      <Link to="/cindy-bundle" className="text-balance hover:underline text-xs sm:text-sm">
        <b>Celebrate our Founder & CEO's 66th birthday!</b>
        <br />
        with 66 real world sex credits. <b>Buy Now</b>
      </Link>
    </div>
  )
}
